import {AccessToken} from "@okta/okta-auth-js";

export function getUserInfo(accessToken: AccessToken | undefined) {
  if (!accessToken) {
    return null;
  }
  const decompiled = decompileToken(accessToken.accessToken);

  return {
    userId: decompiled.userId,
    customerId: decompiled.customerId,
    accountId: decompiled.accountId,
    login: decompiled.sub
  };
}

export interface DecompiledToken {
  customerId: number;
  userId: number;
  accountId?: string;
  exp: number;
  sub: string;
}

export function decompileToken(token: string): DecompiledToken {
  const tokenWithoutHeader = token.split('.')[1];
  if (!tokenWithoutHeader) {
    throw new Error('Tried to interpret invalid token');
  }
  const decoded = decodeURIComponent(atob(tokenWithoutHeader).replace(/(.)/g, (m, p) => {
    let code = p.charCodeAt(0).toString(16).toUpperCase();
    if (code.length < 2) {
      code = "0" + code;
    }
    return "%" + code;
  }));

  return JSON.parse(decoded);
}

export function isTrackUnitUser(accessToken: AccessToken | undefined) {
  if (!accessToken) {
    return null;
  }
  return [
    {customerId: 3}        // TU

  ].filter(
      r => r.customerId === getUserInfo(accessToken)?.customerId
  ).length > 0;
}